import { DateAdapterBase } from '@rschedule/core';
import { Rule } from '@rschedule/core/generators';
import { ICAL_RULES } from '@rschedule/core/rules/ICAL_RULES';
import { StandardDateAdapter } from '@rschedule/standard-date-adapter';

DateAdapterBase.adapter = StandardDateAdapter;
Rule.recurrenceRules = ICAL_RULES;
